import Vue from 'vue'
import Vuex from 'vuex'
import http from '../services/http'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: false,
  // strict: process.env.NODE_ENV !== 'production',
  state: {
    currentUrl: window.location.origin,
    loginUser: null
  },
  mutations: {
    setCurrentUrl (state, payload) {
      state.currentUrl = payload
    },
    setLoginUser (state, payload) {
      state.loginUser = payload
    }
  },
  actions: {
    async getLoginUser ({ commit }) {
      let result = await http.get('/api/account/LoginUser')
      commit('setLoginUser', result.data)
    }
  }
})
